import { useStringFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../constants/featureFlag";
import { OnboardingIntroExperimentVariant } from "../../../constants/onboarding-intro-experiment-variant.enum";

function normalizeVariant(rawVariant: string): OnboardingIntroExperimentVariant {
  const isAssignedVariant =
    rawVariant === OnboardingIntroExperimentVariant.CONTROL ||
    rawVariant === OnboardingIntroExperimentVariant.INTRO_SCREEN;
  if (isAssignedVariant) {
    return rawVariant as OnboardingIntroExperimentVariant;
  }
  return OnboardingIntroExperimentVariant.NONE;
}

export function useOnboardingIntroExperimentVariant(): OnboardingIntroExperimentVariant {
  const rawVariant = useStringFlagValue(
    FeatureFlagVariables.onboardingIntroExperimentVariant,
    OnboardingIntroExperimentVariant.NONE,
    { updateOnContextChanged: true }
  );
  return normalizeVariant(rawVariant);
}
